import React, {useEffect, useContext} from 'react';
import { Grid, Theme } from '@carbon/react';

import {ThemeContext} from '../../context/ThemeProvider';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";

const SsoLogin = () => {
  
  const navigate = useNavigate();
  const theme = useContext(ThemeContext);
  const email = theme.theme.email
  const profileName = theme.theme.profile;
  
  useEffect(() => {
    window.location.href = '/tokens/getTokens';
  }, [])
  
  return (
    <>
        <Theme theme="g90">
            <CommodityHeader />
        </Theme>
      <Grid className={"principal-grid"}>        
      </Grid>
    </>
  );
};

export default SsoLogin;